var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-content',{key:_vm.internIriggerReload},[_c('v-card',{staticClass:"main-card-screen card-animation pl-3 pr-3 pt-1 pb-3",attrs:{"tile":"","elevation":0}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }